var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fill-height":""}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","column":""}},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"accent"}}),_c('br'),_c('v-label',[_vm._v("\n        Saindo da aplicação\n      ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }